import { RouterPaths } from '../../router/paths';

import {
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Calculate as CalculateIcon,
  CurrencyExchange as CurrencyExchangeIcon,
  EditNotifications as EditNotificationsIcon,
  Group as GroupIcon,
  Inventory as InventoryIcon,
  MonetizationOn as MonetizationOnIcon,
  NorthEast as NorthEastIcon,
  Percent as PercentIcon,
  Receipt as ReceiptIcon,
  ReceiptLong as ReceiptLongIcon,
  Summarize as SummarizeIcon,
  SwapCalls as SwapCallsIcon,
  PermDataSetting as PermDataSettingIcon,
  CurrencyBitcoin as CurrencyBitcoinIcon,
  PriceCheck as PriceCheckIcon,
  ManageAccounts as ManageAccountsIcon,
  Dashboard as DashboardIcon,
} from '@mui/icons-material';
import { IconABF } from '../../assets';

export const menuList = [
  {
    path: RouterPaths.Dashboard,
    icon: <DashboardIcon />,
    label: 'dashboard',
  },
  {
    path: RouterPaths.Profiles,
    icon: <GroupIcon />,
    label: 'profiles',
    permission: 'READ_PROFILES',
  },
  {
    path: RouterPaths.Transactions,
    icon: <ReceiptLongIcon />,
    label: 'transactions',
    permission: 'READ_TRANSACTIONS',
  },
  {
    path: RouterPaths.Withdrawals,
    icon: <NorthEastIcon />,
    label: 'withdrawals',
    permission: 'READ_TRANSACTIONS',
  },
  {
    path: RouterPaths.Invoices,
    icon: <ReceiptIcon />,
    label: 'invoices',
    permission: 'READ_WALLET_DEPOSIT_INVOICES',
  },
  {
    path: RouterPaths.ExchangeRates,
    icon: <CurrencyExchangeIcon />,
    label: 'exchange-rates',
    permission: 'READ_RATES',
  },
  {
    path: RouterPaths.FeeGroups,
    icon: <MonetizationOnIcon />,
    label: 'fees',
    permission: 'READ_FEE_GROUPS',
  },
  {
    path: RouterPaths.ProviderFees,
    icon: <PriceCheckIcon />,
    label: 'provider-fees',
    permission: 'READ_EXCHANGE_PROVIDERS',
  },
  {
    path: RouterPaths.ExchangeFeeGroups,
    icon: <PercentIcon />,
    label: 'exchange-fees',
    permission: 'READ_RATE_MARKUP_GROUPS',
  },
  {
    path: RouterPaths.BlockchainFeeMarkups,
    icon: <CurrencyBitcoinIcon />,
    label: 'blockchain-fee-markups',
    permission: 'READ_BLOCKCHAIN_FEE_MARKUPS',
  },
  {
    path: RouterPaths.MerchantCoinConfig,
    icon: <PermDataSettingIcon />,
    label: 'merchant-coin-configs',
    permission: 'READ_MERCHANT_COIN_CONFIGS',
  },
  {
    path: RouterPaths.Reports,
    icon: <SummarizeIcon />,
    label: 'reports',
    permission: 'READ_REPORTS',
  },
  {
    path: RouterPaths.Dictionaries,
    icon: <InventoryIcon />,
    label: 'dictionaries',
  },
  {
    path: RouterPaths.UserAndRoles,
    icon: <ManageAccountsIcon />,
    label: 'users-and-roles',
    permission: 'READ_ROLES',
  },
  {
    path: RouterPaths.BlockchainFee,
    icon: <CalculateIcon />,
    label: 'blockchain-fee',
    permission: 'READ_TRANSIT_ADDRESSES',
  },
  {
    path: RouterPaths.TransitAddresses,
    icon: <SwapCallsIcon />,
    label: 'transit-addresses',
    permission: 'READ_TRANSIT_ADDRESSES',
  },
  {
    path: RouterPaths.Providers,
    icon: <AccountBalanceWalletIcon />,
    label: 'providers',
    permission: 'READ_EXCHANGE_PROVIDERS',
  },
  {
    path: RouterPaths.ABFPaymentApps,
    icon: <IconABF height={20} width={20} />,
    label: 'abf-payment-apps',
    permission: 'READ_APPLICATIONS',
  },
  {
    path: RouterPaths.NotificationTemplates,
    icon: <EditNotificationsIcon />,
    label: 'notification-templates',
    permission: 'READ_NOTIFICATION_TEMPLATES',
  },
] as const;
